import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import { cloneElement, type ReactElement, type ReactNode } from 'react';

import arrowStyles from '../shared/floating-arrow.module.css';
import styles from './Tooltip.module.css';

export type TooltipEffect = 'light' | 'dark';
export type TooltipSide = 'top' | 'bottom' | 'left' | 'right';
export type TooltipAlign = 'start' | 'center' | 'end';

export interface TooltipProps {
  children: ReactElement;
  className?: string;
  content: ReactNode;
  effect?: TooltipEffect;
  side?: TooltipSide;
  align?: TooltipAlign;
}

export function Tooltip({ align = 'center', children, className, content, effect = 'dark', side = 'top' }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={(triggerProps) => cloneElement(children, triggerProps)} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner align={align} className={styles.positioner} side={side} sideOffset={6}>
          <BaseTooltip.Popup className={[styles.popup, className].filter(Boolean).join(' ')} data-effect={effect} role="tooltip">
            {content}
            <BaseTooltip.Arrow className={[styles.arrow, arrowStyles.arrow].join(' ')} />
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
